import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMobile } from '@monorepo-web/utils';
import { BotaoContainer, HeaderContainerStyle } from './style';
export function Container(props) {
    var _a;
    return _jsx(BotaoContainer, Object.assign({ floatLeft: (_a = props.floatLeft) !== null && _a !== void 0 ? _a : false }, { children: props.children }));
}
export function HeaderContainer(props) {
    const isMobile = useIsMobile();
    let isBreadcrumb = false;
    if (props.children && props.children[0]['props']['screen']) {
        isBreadcrumb = true;
    }
    return (_jsx(HeaderContainerStyle, Object.assign({ isMobile: isMobile && !isBreadcrumb }, { children: props.children })));
}
